export interface DuplicateWarningEntry {
  projectId: number;
  projectLabel: string;
  filedBy: string | null;
  filedAt: string | null;
}

interface DuplicateWarningProps {
  duplicates: DuplicateWarningEntry[];
  onFileAnyway: () => void;
  onCancel: () => void;
}

// Precheck warns, it never blocks — this banner is purely informational;
// "File anyway" always proceeds.
export function DuplicateWarning({
  duplicates,
  onFileAnyway,
  onCancel,
}: DuplicateWarningProps) {
  if (duplicates.length === 0) {
    return null;
  }

  return (
    <div
      role="alert"
      className="flex flex-col gap-2 rounded-md border border-amber-300 bg-amber-50 p-3"
    >
      <p className="text-sm font-medium text-amber-800">
        This email looks like it&rsquo;s already been filed to{" "}
        {duplicates.length === 1 ? "this project" : "these projects"}:
      </p>
      <ul className="flex flex-col gap-1 text-sm text-amber-800">
        {duplicates.map((dup) => (
          <li key={dup.projectId}>
            <span className="font-medium">{dup.projectLabel}</span>
            {dup.filedBy && <span> — filed by {dup.filedBy}</span>}
            {dup.filedAt && (
              <span> on {new Date(dup.filedAt).toLocaleString()}</span>
            )}
          </li>
        ))}
      </ul>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={onFileAnyway}
          className="rounded-md bg-amber-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-amber-700"
        >
          File anyway
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="rounded-md border border-amber-300 px-3 py-1.5 text-sm font-medium text-amber-800 hover:bg-amber-100"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
